'use client';

import React, { createContext, useContext } from 'react';

interface RuntimeConfig {
  serverUrl: string;
  payloadUrl: string;
  environment: string;
  isLive: boolean;
}

const ConfigContext = createContext<RuntimeConfig | undefined>(undefined);

export const ConfigProvider: React.FC<{
  children: React.ReactNode;
  config: RuntimeConfig;
}> = ({ children, config }) => {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = (): RuntimeConfig => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within ConfigProvider');
  }
  return context;
};
